import { generatePath } from 'react-router';

import { ENV_BASE_URL } from 'env';
import { TParams, TRouteName } from 'route/types';
import { ROUTES } from 'route/constants/routes';

export function getUrl(
    routeName: TRouteName,
    params?: TParams,
    includeDomain?: boolean,
    external?: boolean
): string {
    const path = ROUTES[routeName];

    if (!path) return '/';

    if (external) return `${ENV_BASE_URL}${path}`;

    // generatePath only accepts string params; stringify TParams' numbers/booleans.
    const stringParams = params
        ? Object.fromEntries(
              Object.entries(params).map(([key, value]) => [
                  key,
                  value === undefined ? undefined : String(value),
              ])
          )
        : undefined;

    let generatedPath = generatePath(path, stringParams);

    if (includeDomain) {
        const { protocol, hostname, port } = window.location;
        const portString = port ? `:${port}` : '';
        const domainUrl = `${protocol}//${hostname}${portString}`;

        generatedPath = `${domainUrl}${generatedPath}`;
    }

    return generatedPath;
}
